export const UserAccessFilterOptions = [
  {value: 'email', label: 'Email', type: 'string'},
  {value: 'status', label: 'Status', type: 'status'},
  {value: 'role', label: 'Role', type: 'role'},
]
